module.exports = __webpack_public_path__ + "static/img/whccb.4cce3ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/whccb.png
// module id = 6fwX
// module chunks = 93